export default {
  Detail: {
    title: "Thu hồi theo nhân viên",
    ProcessDate: "Ngày thu hồi",
    Reason: "Lý do thu hồi",
    attach: "Đính kèm",
    addEmployee: "Thêm nhân viên",
    assetbyEmployee: "Tài sản được thu hồi",
    attachFile: "Tài liệu đính kèm",
    addAsset: "Thêm tài sản",
    assetType: "Loại tài sản",
    quantity: "Số lượng",
    assetCode: "Mã tài sản",
    assetName: "Tên tài sản",
    location: "Vị trí tài sản",
    specification: "Quy cách",
    addAttach: "Thêm tệp đính kèm",
    fileName: "Tệp đính kèm",
    size: "Dung lượng",
    dowload: "Tải về",
    EmployeeName: "Nhân viên sử dụng",
    AllocationType: "Đối tượng sử dụng",
    OrganizationUnitName: "Đơn vị sử dụng",
    RepresentativeName: "Người đại diện",
    Quantity: "Số lượng sử dụng",
    QuantityReduce: "Số lượng thu hồi",
    Location: "Vị trí tài sản",
    AssetStatus: "Tình trạng",
    EmptyAttact: "Chưa có tệp đính kèm nào",
    WarningTooQuantity: "Số lượng thu hồi phải nằm trong khoảng từ 1 đến ##0##.",
    OccurenceDateInValid:
      "Ngày thu hồi không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất (##0##)",
    ErrorSelectEmployeeInactive:
      "Chỉ được thu hồi cho nhân viên đang theo dõi. Vui lòng kiểm tra lại!",
    ErrorSelectEmployeeNotHasAsset:
      "Chỉ được thu hồi tài sản với nhân viên đã cấp phát tài sản. Vui lòng kiểm tra lại!",
    ErrorSelectEmployeeMix:
      "Bạn đang chọn cả nhân viên ngừng theo dõi để thu hồi. Bạn có muốn hệ thống chỉ thực hiện thu hồi cho nhân viên đang theo dõi không?",
    ErrorSelectEmployeeExistNotHasAsset:
      "Chỉ được thu hồi tài sản với nhân viên đã cấp phát tài sản. Bạn có muốn tiếp tục thu hồi tài sản không?",
    ErrorNoEmployee: "Chưa chọn nhân viên để thu hồi. Vui lòng kiểm tra lại.",
    ErrorDetailEmpty: "Chưa chọn tài sản thu hồi cho nhân viên <<{0}>>. Vui lòng kiểm tra lại.",
    ErrorQuantiryEqual0:
      "Chưa nhập số lượng cho tài sản <<{0}>> - nhân viên <<{1}>>. Vui lòng kiểm tra lại.",
    ErrorQuantiryGreaterRemainQuantity:
      "Số lượng thu hồi lớn hơn số lượng tồn của tài sản <<{0}>> - nhân viên <<{1}>>. Vui lòng kiểm tra lại.",
    NotParentFromLocation: "Chỉ được thu hồi tài sản của vị trí tài sản ở cấp chi tiết nhất.",
    NotAsset: "Vị trí tài sản không được để trống.",
    ChangeDataEmployee: "Dữ liệu của nhân viên <<{0}>> đã bị thay đổi. Bạn có muốn xóa không?",
  },
};
